function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import clamp from 'lodash.clamp';
import { assertNotNull } from '@deephaven/utils';
import GridUtils from "../GridUtils.js";
import GridMouseHandler from "../GridMouseHandler.js";
var SLOPPY_CLICK_DISTANCE = 5;
var SCROLL_INTERVAL = 1000 / 60;
var SCROLL_DELTA = 10;
/**
 * Gets info about a visible column
 * @param visibleIndex The visible index to get info for
 * @param depth The header depth to get info for
 * @param metrics Grid metrics
 * @param model Grid model
 * @returns The column info at the depth.
 * If the column is not in a group at that depth, returns the info for the base column.
 * Returns null if the column is not visible.
 */
function getColumnInfo(visibleIndex, depth, metrics, model) {
  var _modelColumns$get;
  var modelColumns = metrics.modelColumns,
    movedColumns = metrics.movedColumns,
    allColumnXs = metrics.allColumnXs,
    columnCount = metrics.columnCount,
    allColumnWidths = metrics.allColumnWidths,
    userColumnWidths = metrics.userColumnWidths,
    calculatedColumnWidths = metrics.calculatedColumnWidths,
    floatingLeftWidth = metrics.floatingLeftWidth,
    maxX = metrics.maxX;
  if (depth == null || visibleIndex == null || visibleIndex > columnCount || visibleIndex < 0) {
    return null;
  }
  var modelIndex = (_modelColumns$get = modelColumns.get(visibleIndex)) !== null && _modelColumns$get !== void 0 ? _modelColumns$get : GridUtils.getModelIndex(visibleIndex, movedColumns);
  var group = model.getColumnHeaderGroup(modelIndex, depth);
  var isColumnGroup = group != null;
  var left;
  var right;
  var range;
  if (group != null) {
    var _allColumnXs$get, _allColumnXs$get2, _allColumnWidths$get;
    var _group$getVisibleRang = group.getVisibleRange(movedColumns),
      _group$getVisibleRang2 = _slicedToArray(_group$getVisibleRang, 2),
      startVisibleIndex = _group$getVisibleRang2[0],
      endVisibleIndex = _group$getVisibleRang2[1];
    left = (_allColumnXs$get = allColumnXs.get(startVisibleIndex)) !== null && _allColumnXs$get !== void 0 ? _allColumnXs$get : floatingLeftWidth;
    right = ((_allColumnXs$get2 = allColumnXs.get(endVisibleIndex)) !== null && _allColumnXs$get2 !== void 0 ? _allColumnXs$get2 : maxX) + ((_allColumnWidths$get = allColumnWidths.get(endVisibleIndex)) !== null && _allColumnWidths$get !== void 0 ? _allColumnWidths$get : 0);
    range = [startVisibleIndex, endVisibleIndex];
  } else {
    var _ref, _ref2, _allColumnWidths$get2;
    var possibleLeft = allColumnXs.get(visibleIndex);
    if (possibleLeft == null) {
      return null;
    }
    left = possibleLeft;
    right = left + ((_ref = (_ref2 = (_allColumnWidths$get2 = allColumnWidths.get(visibleIndex)) !== null && _allColumnWidths$get2 !== void 0 ? _allColumnWidths$get2 : userColumnWidths.get(modelIndex)) !== null && _ref2 !== void 0 ? _ref2 : calculatedColumnWidths.get(modelIndex)) !== null && _ref !== void 0 ? _ref : 0);
    range = [visibleIndex, visibleIndex];
  }
  return {
    visibleIndex,
    modelIndex,
    left,
    right,
    width: right - left,
    isColumnGroup,
    range,
    depth
  };
}
class GridColumnMoveMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "cursor", null);
    _defineProperty(this, "draggingOffset", void 0);
    _defineProperty(this, "initialOffset", void 0);
    _defineProperty(this, "initialGridPoint", void 0);
    _defineProperty(this, "scrollingInterval", void 0);
    _defineProperty(this, "scrollingDirection", void 0);
    _defineProperty(this, "draggingColumn", null);
  }
  setScrollInterval(grid, direction) {
    if (this.scrollingInterval != null && direction === this.scrollingDirection) {
      return;
    }
    this.scrollingDirection = direction;
    this.scrollingInterval = window.setInterval(() => {
      var metrics = grid.metrics;
      if (!metrics) {
        return;
      }
      var left = metrics.left,
        lastLeft = metrics.lastLeft,
        leftOffset = metrics.leftOffset,
        userColumnWidths = metrics.userColumnWidths,
        calculatedColumnWidths = metrics.calculatedColumnWidths,
        movedColumns = metrics.movedColumns,
        allColumnWidths = metrics.allColumnWidths;
      var nextLeft = left;
      var nextOffset = leftOffset;
      if (direction === 'left') {
        nextOffset -= SCROLL_DELTA;
        while (nextOffset < 0) {
          var _userColumnWidths$get;
          nextLeft -= 1;
          var modelIndex = GridUtils.getModelIndex(left - 1, movedColumns);
          var prevColumnWidth = (_userColumnWidths$get = userColumnWidths.get(modelIndex)) !== null && _userColumnWidths$get !== void 0 ? _userColumnWidths$get : calculatedColumnWidths.get(modelIndex);
          if (prevColumnWidth === undefined) {
            nextOffset = 0;
          } else {
            nextOffset += prevColumnWidth;
          }
          if (nextLeft < 0) {
            nextOffset = 0;
            nextLeft = 0;
          }
        }
      } else {
        nextOffset += SCROLL_DELTA;
        var leftColumnWidth = allColumnWidths.get(left);
        while (leftColumnWidth !== undefined && nextOffset > leftColumnWidth) {
          var _userColumnWidths$get2;
          nextLeft += 1;
          nextOffset -= leftColumnWidth;
          var _modelIndex = GridUtils.getModelIndex(left + 1, movedColumns);
          leftColumnWidth = (_userColumnWidths$get2 = userColumnWidths.get(_modelIndex)) !== null && _userColumnWidths$get2 !== void 0 ? _userColumnWidths$get2 : calculatedColumnWidths.get(_modelIndex);
          if (nextLeft > lastLeft) {
            nextOffset = 0;
            nextLeft = lastLeft;
          }
        }
      }
      var _grid$state = grid.state,
        mouseX = _grid$state.mouseX,
        mouseY = _grid$state.mouseY;
      if (metrics == null || mouseX == null || mouseY == null) {
        return;
      }
      this.moveDraggingColumn(mouseX, grid, direction === 'left' ? -SCROLL_DELTA : SCROLL_DELTA);
      grid.setState({
        left: nextLeft,
        leftOffset: nextOffset
      });
      if (direction === 'left' && nextLeft === 0 && leftOffset === 0 || direction === 'right' && nextLeft === lastLeft) {
        this.clearScrollInterval();
      }
    }, SCROLL_INTERVAL);
  }
  clearScrollInterval() {
    this.scrollingDirection = undefined;
    window.clearInterval(this.scrollingInterval);
    this.scrollingInterval = undefined;
  }
  onLeave() {
    this.clearScrollInterval();
    return false;
  }
  onDown(gridPoint, grid) {
    var model = grid.props.model;
    var x = gridPoint.x,
      column = gridPoint.column,
      columnHeaderDepth = gridPoint.columnHeaderDepth;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('Metrics not set');
    var columnInfo = getColumnInfo(column, columnHeaderDepth, metrics, model);
    if (column == null || columnInfo == null || columnHeaderDepth == null) {
      return false;
    }

    // Can't drag a base column from the empty group area
    if (columnHeaderDepth > 0 && !columnInfo.isColumnGroup) {
      return false;
    }
    var rowHeaderWidth = metrics.rowHeaderWidth;
    this.initialGridPoint = gridPoint;
    this.draggingColumn = null;
    this.cursor = null;
    if (columnInfo.modelIndex != null && columnHeaderDepth != null && model.isColumnMovable(columnInfo.modelIndex, columnHeaderDepth)) {
      this.draggingOffset = x - columnInfo.left - rowHeaderWidth;
      this.initialOffset = this.draggingOffset;
    }
    return false;
  }
  onDrag(gridPoint, grid, event) {
    if (this.draggingOffset === undefined || this.initialGridPoint === undefined || this.initialOffset === undefined) {
      return false;
    }
    var mouseX = gridPoint.x,
      mouseY = gridPoint.y;
    var columnHeaderDepth = this.initialGridPoint.columnHeaderDepth;
    var model = grid.props.model;
    var draggingColumn = this.draggingColumn;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('Metrics not set');

    // before considering it a drag, the mouse must have moved a minimum distance
    // this prevents click actions from triggering a drag state
    if (!draggingColumn && Math.abs(this.initialGridPoint.x - mouseX) < SLOPPY_CLICK_DISTANCE && Math.abs(this.initialGridPoint.y - mouseY) < SLOPPY_CLICK_DISTANCE) {
      return false;
    }

    // Get the initial dragging column info
    if (draggingColumn == null) {
      var initialColumnInfo = getColumnInfo(this.initialGridPoint.column, columnHeaderDepth, metrics, model);
      if (!initialColumnInfo || columnHeaderDepth == null) {
        return false;
      }
      if (!model.isColumnMovable(initialColumnInfo.modelIndex)) {
        return false;
      }

      // Disallow dragging from the blank space in column header groups
      if (columnHeaderDepth > 0 && !initialColumnInfo.isColumnGroup) {
        return false;
      }
      if (initialColumnInfo.range[0] == null) {
        return false;
      }
      draggingColumn = {
        range: initialColumnInfo.range,
        depth: columnHeaderDepth,
        left: initialColumnInfo.left,
        width: initialColumnInfo.width
      };
      var startColumn = getColumnInfo(draggingColumn.range[0], 0, metrics, model);
      var endColumn = getColumnInfo(draggingColumn.range[1], 0, metrics, model);

      // Group goes off the table. Drag and drop could be wonky here
      // Column draws only use columns that are partially visible too
      // So this could cause rendering errors if we tried dragging it
      if (!startColumn || !endColumn) {
        return false;
      }
      this.draggingColumn = draggingColumn;
      grid.setState({
        draggingColumn,
        isDragging: true
      });
    }

    /**
     * At this point, we have determined we are actually dragging a column
     */
    this.cursor = 'move';
    this.moveDraggingColumn(gridPoint.x, grid, event.movementX);
    return true;
  }

  /**
   * Moves a dragging column, if possible, the specified distance
   * @param mouseX The point the move was initiated from
   * @param grid The Grid component
   * @param deltaX The distance of the move
   */
  moveDraggingColumn(mouseX, grid, deltaX) {
    var _draggingParentGroup$;
    if (this.draggingOffset === undefined || this.initialGridPoint === undefined || this.initialOffset === undefined || this.draggingColumn == null || deltaX === 0) {
      return;
    }
    var metrics = grid.metrics;
    assertNotNull(metrics, 'Metrics not set');
    var gridX = metrics.gridX;

    // Cursor has moved past the column drag bounds, don't move the column until we hit the initial offset point again
    if (this.initialOffset !== this.draggingOffset) {
      // Pre move < Initial < Post move or vice-versa
      // User crossed back past the iniital offset point, so we can start moving again
      if (this.draggingOffset < this.initialOffset && this.initialOffset < this.draggingOffset + deltaX || this.draggingOffset > this.initialOffset && this.initialOffset > this.draggingOffset + deltaX) {
        this.draggingOffset = this.initialOffset;
      } else {
        // Column can't move since we aren't back at the initial offset yet
        this.draggingOffset += deltaX;
      }
      this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
        left: mouseX - this.draggingOffset - gridX
      });
      grid.setState({
        draggingColumn: this.draggingColumn
      });
      return;
    }
    var draggingColumnDepth = this.draggingColumn.depth;
    var model = grid.props.model;
    var movedColumns = grid.state.movedColumns;
    var floatingLeftWidth = metrics.floatingLeftWidth,
      width = metrics.width,
      columnHeaderMaxDepth = metrics.columnHeaderMaxDepth,
      allColumnXs = metrics.allColumnXs;
    var isDraggingLeft = deltaX < 0;
    var draggingColumn = getColumnInfo(this.draggingColumn.range[0], draggingColumnDepth, metrics, model);
    if (!draggingColumn) {
      return;
    }

    // The returned left/right are the original position, not dragged position
    // This is where the dragging column's floating position accounting for dragged distance
    var floatingDraggingLeft = mouseX - this.draggingOffset - gridX;
    var floatingDraggingRight = floatingDraggingLeft + draggingColumn.width;
    this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
      left: floatingDraggingLeft
    });
    grid.setState({
      draggingColumn: this.draggingColumn
    });
    var swapColumn = getColumnInfo(GridUtils.getColumnAtX(clamp(isDraggingLeft ? floatingDraggingLeft : floatingDraggingRight, floatingLeftWidth, width) + gridX, metrics, true), draggingColumnDepth, metrics, model);
    var parentGroup = model.getColumnHeaderParentGroup(draggingColumn.modelIndex, draggingColumn.depth);
    if (!swapColumn) {
      return;
    }

    // Check if we should pin to the edge of the parent
    if (parentGroup !== undefined) {
      var parentVisibleRange = parentGroup.getVisibleRange(movedColumns);
      // Cannot move to this left position, pin to left of parent
      if (swapColumn.visibleIndex < parentVisibleRange[0]) {
        var _allColumnXs$get3;
        var _newMovedColumns = this.moveColumn(draggingColumn, parentVisibleRange[0], movedColumns);
        this.draggingOffset = mouseX - ((_allColumnXs$get3 = allColumnXs.get(parentVisibleRange[0])) !== null && _allColumnXs$get3 !== void 0 ? _allColumnXs$get3 : 0);
        this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
          left: mouseX - this.draggingOffset - gridX
        });
        this.clearScrollInterval();
        grid.setState({
          draggingColumn: this.draggingColumn,
          movedColumns: _newMovedColumns
        });
        return;
      }

      // Pin to the right of parent
      if (swapColumn.visibleIndex > parentVisibleRange[1]) {
        var _getColumnInfo;
        var _newMovedColumns2 = this.moveColumn(draggingColumn, parentVisibleRange[1] - (draggingColumn.range[1] - draggingColumn.range[0]), movedColumns);
        var _ref3 = (_getColumnInfo = getColumnInfo(parentVisibleRange[1], 0, metrics, model)) !== null && _getColumnInfo !== void 0 ? _getColumnInfo : {},
          _ref3$right = _ref3.right,
          parentRight = _ref3$right === void 0 ? 0 : _ref3$right;
        this.draggingOffset = mouseX - (parentRight - draggingColumn.width);
        this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
          left: mouseX - this.draggingOffset - gridX
        });
        this.clearScrollInterval();
        grid.setState({
          draggingColumn: this.draggingColumn,
          movedColumns: _newMovedColumns2
        });
        return;
      }
    }

    // Hit an unmovable column, move to the first available position next to it
    if (!model.isColumnMovable(swapColumn.modelIndex)) {
      var toVisibleIndex = swapColumn.visibleIndex;
      if (isDraggingLeft) {
        toVisibleIndex += 1;
        while (toVisibleIndex < draggingColumn.visibleIndex && !model.isColumnMovable(GridUtils.getModelIndex(toVisibleIndex, movedColumns))) {
          toVisibleIndex += 1;
        }
      } else {
        toVisibleIndex -= 1;
        while (toVisibleIndex > draggingColumn.visibleIndex && !model.isColumnMovable(GridUtils.getModelIndex(toVisibleIndex, movedColumns))) {
          toVisibleIndex -= 1;
        }
      }
      if (toVisibleIndex !== draggingColumn.visibleIndex) {
        if (!isDraggingLeft) {
          // Offset for range if dragging right
          toVisibleIndex -= draggingColumn.range[1] - draggingColumn.range[0];
        }
        var _newMovedColumns3 = this.moveColumn(draggingColumn, toVisibleIndex, movedColumns);
        grid.setState({
          movedColumns: _newMovedColumns3,
          draggingColumn: this.draggingColumn
        });
      }
      var toColumnInfo = getColumnInfo(toVisibleIndex, 0, metrics, model);
      if (isDraggingLeft) {
        var _toColumnInfo$left;
        this.draggingOffset = mouseX - ((_toColumnInfo$left = toColumnInfo === null || toColumnInfo === void 0 ? void 0 : toColumnInfo.left) !== null && _toColumnInfo$left !== void 0 ? _toColumnInfo$left : 0);
      } else {
        var _toColumnInfo$right;
        this.draggingOffset = mouseX - (((_toColumnInfo$right = toColumnInfo === null || toColumnInfo === void 0 ? void 0 : toColumnInfo.right) !== null && _toColumnInfo$right !== void 0 ? _toColumnInfo$right : 0) - draggingColumn.width);
      }
      this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
        left: mouseX - this.draggingOffset - gridX
      });
      grid.setState({
        draggingColumn: this.draggingColumn
      });
      return;
    }
    if (floatingDraggingLeft <= floatingLeftWidth) {
      this.setScrollInterval(grid, 'left');
    } else if (floatingDraggingRight > width) {
      this.setScrollInterval(grid, 'right');
    } else {
      this.clearScrollInterval();
    }

    // Can't swap a column with itself
    if (swapColumn.visibleIndex === draggingColumn.visibleIndex) {
      return;
    }

    // Can't swap a column to the left when dragging right or vice versa
    if (isDraggingLeft && draggingColumn.visibleIndex < swapColumn.visibleIndex || !isDraggingLeft && draggingColumn.visibleIndex > swapColumn.visibleIndex) {
      return;
    }
    var switchPoint = swapColumn.left + swapColumn.width * 0.5;
    var draggingParentGroup = model.getColumnHeaderParentGroup(draggingColumn.modelIndex, draggingColumn.depth);

    // Get the highest level group that is not the common base group
    // This group is what we need to drag past
    var maxDepthSwapGroup;
    var maxSwapDepth = ((_draggingParentGroup$ = draggingParentGroup === null || draggingParentGroup === void 0 ? void 0 : draggingParentGroup.depth) !== null && _draggingParentGroup$ !== void 0 ? _draggingParentGroup$ : columnHeaderMaxDepth) - 1;
    while (maxSwapDepth >= 0 && maxDepthSwapGroup === undefined) {
      maxDepthSwapGroup = model.getColumnHeaderGroup(swapColumn.modelIndex, maxSwapDepth);
      maxSwapDepth -= 1;
    }
    var newMovedColumns;
    if (isDraggingLeft && floatingDraggingLeft < switchPoint && (!maxDepthSwapGroup || swapColumn.visibleIndex === maxDepthSwapGroup.getVisibleRange(movedColumns)[0])) {
      newMovedColumns = this.moveColumn(draggingColumn, swapColumn.range[0], movedColumns);
    }
    if (!isDraggingLeft && floatingDraggingRight > switchPoint && (!maxDepthSwapGroup || swapColumn.visibleIndex === maxDepthSwapGroup.getVisibleRange(movedColumns)[1])) {
      newMovedColumns = this.moveColumn(draggingColumn, swapColumn.range[1] - (draggingColumn.range[1] - draggingColumn.range[0]), movedColumns);
    }
    if (!newMovedColumns) {
      return;
    }
    this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
      left: floatingDraggingLeft
    });
    grid.setState({
      movedColumns: newMovedColumns,
      draggingColumn: this.draggingColumn
    });
  }

  /**
   * Applies the column move and updates draggingColumn in the mouse handler
   * Does not check if the move is valid
   * @param draggingColumn The dragging column info
   * @param to The index to move the column or range to
   * @param movedColumns The array of column moves
   * @returns A new array of column moves
   */
  moveColumn(draggingColumn, to, movedColumns) {
    var newMovedColumns = draggingColumn.isColumnGroup ? GridUtils.moveRange(draggingColumn.range, to, movedColumns) : GridUtils.moveItem(draggingColumn.visibleIndex, to, movedColumns);
    var moveDistance = to - draggingColumn.range[0];
    var newDraggingRange = [draggingColumn.range[0] + moveDistance, draggingColumn.range[1] + moveDistance];
    if (this.draggingColumn) {
      this.draggingColumn = _objectSpread(_objectSpread({}, this.draggingColumn), {}, {
        range: newDraggingRange
      });
    }
    return newMovedColumns;
  }
  onUp(gridPoint, grid) {
    this.cursor = null;
    this.clearScrollInterval();
    if (this.draggingOffset != null) {
      this.draggingOffset = undefined;
      grid.setState({
        draggingColumn: null,
        isDragging: false
      });
      return true;
    }
    return false;
  }
}
export default GridColumnMoveMouseHandler;
//# sourceMappingURL=GridColumnMoveMouseHandler.js.map